<script lang="ts">
  import { header } from './data';
</script>

<section class="print:mb-2">
  <h1
    class="text-xl md:text-2xl md:text-3xl font-bold mb-2 md:mb-0 print:text-xl print:mb-1"
  >
    {header.fullName}
  </h1>
  <div class="print:mb-1">
    <span
      class="hidden md:inline text-xl md:text-2xl print:inline print:text-sm"
      >{header.address.concat(' ')}</span
    ><span
      class="hidden md:inline text-xl md:text-2xl print:inline print:text-sm"
    >
      |
    </span><a
      class="hidden md:inline text-xl md:text-2xl print:inline print:text-sm"
      href={`tel:${header.tel}`}
      rel="noreferrer">{header.tel}</a
    >
    <span
      class="hidden md:inline text-xl md:text-2xl print:inline print:text-sm"
    >
      |
    </span>
    <a
      class="hidden md:inline text-xl md:text-2xl print:inline print:text-sm"
      href={`mailto:${header.email}`}
      rel="noreferrer">{header.email}</a
    >
  </div>
  <div class="text-base block md:hidden print:hidden">
    <p>{header.address}</p>
    <a href={`tel:${header.tel}`}>{header.tel}</a>
    <div>
      <a href={`mailto:${header.email}`}>{header.email}</a>
    </div>
  </div>
  <div class="print:mb-1">
    {#each header.urls as url, idx}
      {#if idx < header.urls.length - 1}
        <a
          class="text-blue-700 hidden md:inline print:inline print:text-sm"
          href={url}
          rel="noreferrer"
          target="_blank"
        >
          {url.replace(/(^\w+:|^)\/\//, '').slice(0, -1)}
        </a><span class="hidden md:inline print:inline print:text-sm"> | </span>
      {:else}
        <a
          class="text-blue-700 hidden md:inline print:inline print:text-sm"
          href={url}
          rel="noreferrer"
          target="_blank">{url.replace(/(^\w+:|^)\/\//, '').slice(0, -1)}</a
        >
      {/if}
    {/each}
  </div>
  <div class="text-base block md:hidden print:hidden">
    {#each header.urls as url}
      <div>
        <a class="text-blue-700" href={url} rel="noreferrer" target="_blank">
          {url.replace(/(^\w+:|^)\/\//, '').slice(0, -1)}</a
        >
      </div>
    {/each}
  </div>
</section>
